import { clamp } from "@zetalabs/core";
import { ProcessStatus, ProcessingStatus, TerminationStatus } from "./types";

export function isDone<
	T extends {
		status: ProcessStatus;
		progress: number;
	},
>(items: T[]): boolean {
	return (
		items.length > 0 &&
		items.every(
			(item) => item.status === TerminationStatus.Done && item.progress === 1,
		)
	);
}

export function isRunning<T extends { status: ProcessStatus }>(
	items: T[],
): boolean {
	return (
		items.length > 0 &&
		items.some((item) => {
			return (
				item.status === ProcessingStatus.InProgress ||
				item.status === ProcessingStatus.Preparing
			);
		})
	);
}

export function calcProgress<T extends { progress: number }>(
	items: T[],
): number {
	if (items.length === 0) {
		return 0;
	}

	return clamp(
		items.reduce((acc, item) => {
			return acc + item.progress;
		}, 0) / items.length,
		0,
		1,
	);
}
